import { ContentAndAccordionWrapper, WidgetWrapper } from './styled'

import { Index } from 'hooks/type-of-use-indices'
import React from 'react'
import { TransactionalContextProvider } from './transactional-context/index'
import WidgetApp from './widget-app'
import { usePhuture } from 'context/phuture-sdk'
import { useTourGuide } from 'context/tour-guide/use-tour-guide'
import { useAccount } from 'wagmi'

type WidgetComponentProps = {
  indexInfo: Index
  finishedLoading: boolean
}

/**
 * A container component that has multiple presentation components.
 * This component makes use of several contacts to handle state.
 * It Focuses on visuals
 * UPDATE: indexInfo now contains the network that the index belongs to
 * @param props
 * @returns
 */
export const WidgetComponent: React.FC<WidgetComponentProps> = ({ indexInfo, finishedLoading }) => {
  // context to go here
  const { chain, address } = useAccount()
  const network = chain?.id ?? 1
  const [content, setContent] = React.useState<JSX.Element>()
  const { isConnected } = usePhuture()
  const { run } = useTourGuide()
  const getWalletContent = () => {
    return <WidgetApp indexInfo={indexInfo} finishedLoading={finishedLoading} />
  }

  React.useEffect(() => {
    setContent(getWalletContent())
  }, [network, address, isConnected, run])

  return (
    <TransactionalContextProvider>
      <WidgetWrapper>
        <ContentAndAccordionWrapper
          correctNetwork={isConnected && indexInfo.network === network}
          connected={isConnected}
        >
          {content}
        </ContentAndAccordionWrapper>
      </WidgetWrapper>
    </TransactionalContextProvider>
  )
}
